
import {
  Component,
  Input,
  Output,
  EventEmitter
} from '@angular/core';
import {
  Router
} from '@angular/router';
import { CommonService } from '../services/common.service';
import { CacheService } from '../services/cache.service';
import { CacheKey } from '../constants/cachekey.constants';
import { MenuItem } from '../interfaces/menu-item.interface';
import { environment } from '../../../environments/environment';

@Component({
  // tslint:disable-next-line:component-selector
  selector: '[app-submenu]',
  templateUrl: '../templates/template1/views/app-submenu.component.html',
  styleUrls: [

  ]
})
export class AppSubmenuComponent {
  countryCode: string;
  languageCode: string;
  showMenu = false;
  userInfo: any;
  portalURL: string;
  @Input() menuName: string;
  @Input() menuItems: MenuItem[];
  @Input() level = 0;

  @Output() backClicked = new EventEmitter();
  @Output() openChildPushMenu = new EventEmitter();
  @Output() menuItemClicked = new EventEmitter();

  constructor(
    private _commonService: CommonService,
    private _cacheService: CacheService,
    private _router: Router) {
    this.countryCode = this._cacheService.getCookieValue(CacheKey.countryCode);
    this.languageCode = this._cacheService.getCookieValue(CacheKey.languageCode);
  }


  /**
 * @description To navigare to other moduleslike join or account or corporate
 * @param  {string} moduleName
 * @returns void
 */
  navigateToModule(menuItem: any): void {
    const languageCode = this._cacheService.getCookieValue(CacheKey.languageCode);
    const target = menuItem.openInNewTab ? '_blank' : '_self';
    if (menuItem.url) {
      const queryUrl = '?countryCode=' + this.countryCode + '&languageCode=' + languageCode;
      window.open(menuItem.url + queryUrl, target);
    }
  }

  /**
    * @description Internal Link which is not having a CMS content
    * @param  {any} menuItem
    * @returns void
    */
  navigateToInternalLink(menuItem: MenuItem): void {
    let url = '';
    if (menuItem.portalURL && menuItem.parentURL && menuItem.url && (window.location.origin === menuItem.parentURL)) {
      this._router.navigateByUrl('/' + this.countryCode + menuItem.url);
    } else if (menuItem.parentURL && menuItem.url) {
      const languageCode = this._commonService.getLanguageCode();
      const redirectURL = menuItem.parentURL + (menuItem.url === '/' ? '' : '/' + this.countryCode + menuItem.url);
      url = redirectURL + '?countryCode=' + this.countryCode + '&languageCode=' + languageCode;
      window.location.href = url;
    }
  }

  /**
 * @description Internal Link which is having a CMS content to Other portals
 * @param  {any} menuItem
 * @returns void
 */
  navigateToContentPage(menuItem: MenuItem): void {
    const languageCode = this._cacheService.getCookieValue(CacheKey.languageCode);
    const target = menuItem.openInNewTab ? '_blank' : '_self';
    this.userInfo = this._cacheService.get(CacheKey.UserInfo);
    if (this.userInfo) {
      if (this._cacheService.get(CacheKey.CountryMetaData)) {
        this._commonService.updateCountryCodeinCookie();
      }
      this.portalURL = environment.accountSiteURL + '/' + this.countryCode + '/' + languageCode + '/account/pages';
    } else {
      this.portalURL = environment.corporateUrl + '/' + this.countryCode + '/' + languageCode.toLowerCase();
    }
    const queryUrl = '/' + menuItem.slug;
    window.open(this.portalURL + queryUrl, target);
  }


  /**
   * @description To nvigate the submenu sites
   * @param submenuItems
   */
  navigationToSubMenu(submenuItems: any): void {
    if (submenuItems) {
      window.location.href = submenuItems.routePath;
    }
  }

  /**
   * @description toggle header menu in mobile view
   */
  showHeaderMenu() {
    this.showMenu = !this.showMenu;
  }
  /**
   * Back navigation in Push Menu
   * @param {number} level
   * @memberof AppSubmenuComponent
   */
  goBack(level: number): void {
    this.backClicked.emit();
  }
  /**
   * Called while click on right arrow in menu item
   * @param {*} menu
   * @param {number} level
   * @memberof AppSubmenuComponent
   */
  setPushMenu(menu: any, level: number): void {
    const menuDetail = {
      level: level,
      childs: menu.childs,
      name: menu.name
    };
    this.openChildPushMenu.emit(menuDetail);
  }

  /**
   * When menu item clicked
   * @param {MenuItem} menuItem
   * @memberof AppSubmenuComponent
   */
  itemClicked(menuItem: MenuItem): void {
    if (menuItem && menuItem.childs && menuItem.childs.length > 0) {
      this.setPushMenu(menuItem, this.level);
    } else {
      this.menuItemClicked.emit(menuItem);
    }
  }
}
